import React, { Component } from 'react';

class ImageWithFallback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      isLastFallback: false
    };
    this.handleLoad = this.handleLoad.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  handleLoad() {
    this.setState({ isLoaded: true });
  }

  handleError(e) {
    const { fallbackUrls = [] } = this.props;
    
    // Get current fallback index
    let currentIndex = parseInt(e.target.getAttribute('data-fallback-index') || '-1', 10);
    currentIndex++;
    
    // Check if this will be the last fallback
    const isLast = currentIndex === fallbackUrls.length - 1;
    
    if (currentIndex < fallbackUrls.length) {
      e.target.setAttribute('data-fallback-index', currentIndex);
      e.target.src = fallbackUrls[currentIndex];
      this.setState({ 
        isLoaded: false,
        isLastFallback: isLast 
      });
    } else {
      e.target.onerror = null;
      this.setState({ isLoaded: true });
    }
  }

  render() {
    const { src, fallbackUrls, alt, className, lastFallbackClassName, ...restProps } = this.props;
    const { isLoaded, isLastFallback } = this.state;
    
    // Determine which class to use
    const imageClassName = isLastFallback && lastFallbackClassName 
      ? `${className} ${lastFallbackClassName}` 
      : className;
    
    return (
      <img
        src={src}
        alt={alt}
        className={imageClassName}
        data-fallback-index="-1"
        onLoad={this.handleLoad}
        onError={this.handleError}
        style={{ 
          opacity: isLoaded ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out'
        }}
        {...restProps}
      />
    );
  }
}

export default ImageWithFallback;